import { throttle } from 'lodash';

const handleStickySideBar = () => {
  const sidebarContent = document.getElementById('sticky_sidebar');
  const recurrenceContent = document.getElementById('recurrence__quickbook');
  const quickBook = document.getElementById('quickBook');
  const laptopMediaQuery = window.matchMedia('(min-width: 1024px)');

  if (laptopMediaQuery.matches) {
    sidebarContent.style.width = '35rem';
    window.addEventListener(
      'scroll',
      throttle(() => {
        const contentHeight = sidebarContent.getBoundingClientRect().height;
        const quickBookHeight = quickBook.getBoundingClientRect().height;

        if (contentHeight < 670 || quickBookHeight < 120) {
          sidebarContent.style.top = `${90}px`;
        } else if (contentHeight > 670) {
          const selectedSpaceContent = document.getElementById(
            'selected_spaces'
          );
          if (selectedSpaceContent) {
            const selectedSpaceHeight = selectedSpaceContent.getBoundingClientRect()
              .height;
            if (selectedSpaceHeight > 50 && selectedSpaceHeight < 140) {
              sidebarContent.style.top = `${-150}px`;
            } else if (selectedSpaceHeight > 140 && selectedSpaceHeight < 240) {
              sidebarContent.style.top = `${-290}px`;
            } else if (selectedSpaceHeight > 240 && selectedSpaceHeight < 340) {
              sidebarContent.style.top = `${-330}px`;
            } else if (selectedSpaceHeight > 340 && selectedSpaceHeight < 440) {
              sidebarContent.style.top = `${-580}px`;
            }
            if (recurrenceContent) {
              const recurrenceHeight = recurrenceContent.getBoundingClientRect()
                .height;
              const stickyTop = sidebarContent.style.top.split('px')[0];
              if (recurrenceHeight > 70) {
                sidebarContent.style.top = `${
                  stickyTop - recurrenceHeight + 150
                }px`;
              }
            }
          }
        }
      }, 500)
    );
  }
};

export { handleStickySideBar };
